/**
 * Pages/Panel/Empleados/recibosSinTimbrar.js
 *
 * Recibos de nómina sin timbrar en el listado de Empleados. El backend los calcula
 * (`erp_backend/Utils/recibosSinTimbrar.utils.js`, ahí está la regla) y los manda en
 * `record.recibosSinTimbrar`; aquí sólo se pinta: color de fila, etiqueta, tooltip y aviso.
 */

import fmtFechaDia from "../../../Components/fmtFechaDia";

/** Más oscuro que el rojo de "SBC menor" (#CF1322) para que no se confundan. */
export const COLOR_SIN_TIMBRAR = "#A8071A";

/** Clase de fila de App.css. */
export const CLASE_FILA_SIN_TIMBRAR = "recibo-sin-timbrar";

/** Cuántos recibos lista el tooltip antes de resumir el resto en "y N más". */
export const MAX_RECIBOS_TOOLTIP = 5;

export const numRecibosSinTimbrar = (record) => record?.recibosSinTimbrar?.length || 0;

export const tieneRecibosSinTimbrar = (record) => numRecibosSinTimbrar(record) > 0;

/** Para el aviso de arriba de la tabla: empleados, no recibos. */
export const contarEmpleadosSinTimbrar = (empleados = []) =>
  empleados.filter(tieneRecibosSinTimbrar).length;

/** Encabezado del recibo en el tooltip: "<prenómina> · pago dd/mm/aaaa · Finiquito". */
export const encabezadoRecibo = (r) =>
  [
    r.prenomina,
    r.fechaPago ? `pago ${fmtFechaDia(r.fechaPago)}` : null,
    r.esFiniquito ? "Finiquito" : null,
  ].filter(Boolean).join(" · ");

/** Por qué no está timbrado. */
export const motivoRecibo = (r) =>
  r.motivo === "error"
    ? `Error al timbrar: ${r.error || "sin mensaje del PAC"}`
    : "Pendiente de timbrar (la nómina ya está cerrada)";
